
import { memo, type ReactNode } from "react";
// 如果 styles.ts 文件是针对 Freestar 特有的样式，你可能需要移除或调整它。
import * as styles from "./styles.ts";

// 请替换为你的实际 AdSense 发布商 ID (pub-XXXXXXXXXXXXXXX)
export const AD_CLIENT = "ca-pub-4796148218742064";

// 替换为你的 AdSense 广告单元 ID
export const slot1 = "8365615105"; // 970*90
export const slot2 = "6859562941"; // 对应原 Freestar 的 slot2

export type AdDetails = {
  readonly id: string;
  readonly width: number;
  readonly height: number;
};

// inventory 结构保持不变，但 id 对应的是 AdSense 的 slot ID
export const inventory: Record<string, AdDetails> = {
  BANNER_970X90_1: { id: slot1, width: 970, height: 90 },
  BANNER_160X600_1: { id: slot2, width: 160, height: 600 },
};

export function SetupAds({
  children,
}: {
  readonly children: ReactNode;
}): ReactNode {
  if (process.env.NODE_ENV === "development") {
    return null;
  }
  // AdSense 的加载脚本，通常放在 <head> 或 <body> 顶部
  // data-ad-client 属性是必须的

  return (
    <>
      {/* 注入 AdSense 主加载脚本 */}
        <script
        async={true}
        src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${AD_CLIENT}`}
        crossOrigin="anonymous"
      />
      {children}
    </>
  );
}

export const AdBanner = memo(function AdBanner({
  name,
}: {
  readonly name: "BANNER_160X600_1" | "BANNER_970X90_1";
}): ReactNode {
  const { id, width, height } = inventory[name];
  if (process.env.NODE_ENV === "development") {
    return (
      <div
        style={{
          width: `${width}px`,
          height: `${height}px`,
          background: "#999",
        }}
      />
    );
  }

  return (
    <div
      key={name}
      style={{
        maxWidth: `${width}px`,
        maxHeight: `${height}px`,
        overflow: "hidden",
      }}
    >
      {/* <div className={styles.placeholder} hidden={true} /> */}
      {/* AdSense 广告位容器 */}
      <ins
        className="adsbygoogle" // 必须有这个类名
        style={{ display: "inline-block", width: `${width}px`, height: `${height}px` }} // 必须有 display 和尺寸
        data-ad-client={AD_CLIENT} // 你的发布商 ID
        data-ad-slot={id} // 你的广告单元 ID
      ></ins>
      {/* 触发 AdSense 广告加载。这是 AdSense 的标准方式。 */}
      <script dangerouslySetInnerHTML={{ __html: "(adsbygoogle = window.adsbygoogle || []).push({});" }} />
    </div>
  );
});